import { Injectable } from '@angular/core';
import { of } from 'rxjs';
import { catchError, map, mergeMap, tap } from 'rxjs/operators';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { CrudService } from 'src/app/core/services/crud.service';
import { fetchAgentsList, fetchAgentsListSuccess, fetchAgentsListFailure, activeDeactiveAgent, activeDeactiveAgentFailure, activeDeactiveAgentSuccess } from './agents.action';
import { MatSnackBar } from '@angular/material/snack-bar';

@Injectable()
export class AgentsEffects {
  constructor(
    private actions$: Actions,
    private CrudService: CrudService,
    private snackBar: MatSnackBar
  ) {}

  fetchData$ = createEffect(() =>
    this.actions$.pipe(
      ofType(fetchAgentsList),
      mergeMap((action:any) =>
        this.CrudService.fetchData(
          `Admin/GetAgents?PageNumber=${action.payload.pageNumber}&PageSize=${action.payload.pageSize}
          &SortColumn=${action.payload.sortColumn}&SortOrder=${action.payload.sortOrder}&Search=${action.payload.search}`).pipe(
          map((result) => fetchAgentsListSuccess({ response: result })),
          catchError((error) => of(fetchAgentsListFailure({ error })))
        )
      )
    )
  );

  activeDeactiveAgent$ = createEffect(() =>
      this.actions$.pipe(
        ofType(activeDeactiveAgent),
        mergeMap((action:any) =>
          this.CrudService.putData('Admin/ActivateOrDeactivateUser',action.payload).pipe(
            tap((result) => {
              if (result.successful) {
                this.snackBar.open('Agent Status Updated successfully', '', {
                  duration: 3000,
                  panelClass: 'success',
                });
              } else {
                this.snackBar.open(result.message, '', {
                  duration: 3000,
                  panelClass: 'danger',
                });
              }
            }),
            mergeMap((res) => [
              activeDeactiveAgentSuccess({ response: res.result }),
              fetchAgentsList({
                payload: { pageNumber: 1, pageSize: 10, sortColumn: 'id', sortOrder: 'z', search: '' }
              })
            ]),
            catchError((error) => of(activeDeactiveAgentFailure({ error })))
          )
        )
      )
    );
}
